import {httpPost} from "./http";

const hardwareUrl = window.env.BACKEND_API_URL + "/hardware";

const createHardware = async (car_id, {type, external_id}, signal) => {
    const body = {
        car_id,
        type,
        external_id,
    }
    return await httpPost(hardwareUrl, body, signal);
};

const runCommand = async (hardware_id, action, signal) => {
    const body = {
        action,
    }

    const runCommandUrl = `${hardwareUrl}/${hardware_id}/run_command`
    return await httpPost(runCommandUrl, body, signal);
};

export {
    createHardware,
    runCommand,
};
